
<template>
    <b-container class="bv-example-cambioc401">
            <b-img class="logooc401" :src="logo"></b-img>
               <b-row>
                 <b-col cols="6" class="contenido-login401">
                 <b-img class="caraa401" :src="cara"></b-img>
                 <label class="number401">401</label>
                 </b-col>
                 <b-col cols="6" class="contenido-login401s" >
                    <h6 class="poppins-semi-bold-orange-white-20px">Error 401</h6>
                    <h1 class="no-encontramos-lap401">Lo sentimos... El<br>
                      token caducó<br></h1>
                    <div @click="ingreso()" >
                <b-button block class="boton-ingresoo4011"  ><label  class="ir-al-inicio-de-sesin4011">Reenviar correo para crear contraseña</label></b-button>
                </div>
                 </b-col>
                </b-row>
            <b-modal
              centered
              hide-footer
              no-close-on-backdrop
              no-close-on-esc
              hide-header
              v-model="bloqueo"
            >
            
            <ModalAcep :mensaje="mensaje" :ruta="ruta" :boton="boton" />
            </b-modal>
    </b-container>
   
    </template>
    
    <script>
    import ModalAcep from "../components/ModalAcep.vue";
    import { RepositoryFactory } from "../repositories/RepositoryFactory";

    const resendToken = RepositoryFactory.get("recoverpass");
    
    export default {
      name: "401",
       components: {
        ModalAcep
       },
      
      props: [
        "logo",
        "cara",
        "desgrade",
      ],
      data() { 
            return {
                bloqueo:false, 
                token:"",
                mensaje: "Mensaje enviado exitosamente.",
            ruta: "/login",
            boton: "Aceptar",
            }
        },
        async created() {
           
          this.token=this.$route.params.token;
       
    },
       methods: {
            
            async ingreso() {
                    try {
                        this.load= true;
                        const response = await resendToken.resendToken({"token": this.token});
                        if(this.bloqueo == false){
                    this.bloqueo = true;}
                      
                    }catch (error){

                    }
                   
                }
                
            
        }, 
    };
    
    </script>
    
    <!-- <style>
    .number401 {
        color: var(--blue-violet);
        font-family: var(--font-family-poppins);
        font-size: var(--font-size-xll);
        font-weight: 600;
        letter-spacing: 0;
        line-height: 36px;
        white-space: nowrap;
        margin-top: 12%;
        margin-left: -12%;
        position:absolute;
    }
    .bv-example-cambioc401 {
        background-color: var(--blue-violet);
        margin: 0;
        max-width: 100% !important;
        height: 753px !important;
         text-align: center;
    }
    .logooc401 {
        margin-top: 3%;
    }
    .no-encontramos-lap401 {
      color: var(--orange-white);
      font-family: var(--font-family-poppins);
      font-size: var(--font-size-ll);
      font-weight: 600;
      letter-spacing: 0;
      line-height: 60px;
      margin-top: 4%;
      margin-bottom: 1%;
      min-height: 160px;
      white-space: nowrap;
    }
    .contenido-login401{
      margin-top:5%;
    }
    .contenido-login401s{
      text-align:left;
      margin-top:8% !important;
    }
    .boton-ingresoo4011{
        margin-top:3%;
        width:46%;
        background-color: var(--white) !important;
        border-radius: 10px !important;
        height: 50px;
        text-align: center;
        border-color:transparent !important ;
    }
    .boton-ingresoo4011:hover{
        background: var(--hawkes-blue) !important;
    }
    .ir-al-inicio-de-sesin4011 {
        color: var(--blue-violet);
        font-family: var(--font-family-poppins);
        font-size: var(--font-size-sl);
        font-weight: 600;
        letter-spacing: 0;
        line-height: 34px;
        
    }
    .caraa401{
          margin-top: 17%;
        margin-left: 27%;
    }
    @media (max-width: 1922px) {
    .bv-example-cambioc401 {
        height: 969px !important;
    }
    .number401 {
            margin-top: 11.5%;
        margin-left: -9.5%;
    }
    }
    @media (max-width: 1540px) {
    .bv-example-cambioc401 {
        height: 753px !important;
    }
    .number401 {
        margin-top: 10.5%;
        margin-left: -11.8%;
    }
    .caraa401{
        margin-top: 14%;
    }
    }
    @media (max-width: 1370px) {
        .logooc401 {
    margin-top: 2%;
    width: 16%;
}
.caraa401 {
    margin-top: 13%;
    width: 50%;
}
.contenido-login401s {
    margin-top: 7% !important;
}
.number401 {
    margin-top: 10%;
    margin-left: -12.3%;
}
    }
    @media (max-width: 1280px) {
      .bv-example-cambioc401 {
        height: 609px !important;
    }
    .contenido-login401s {
        margin-top: 7% !important;
    }
    .number401 {
            margin-top: 10%;
        margin-left: -12.5%;
    }
    }
    @media (max-width: 1100px) {
       .bv-example-cambioc401 {
        height: 506px !important;
    }
    .caraa401 {
        margin-top: 12%;
        width: 54%;
    }
    .no-encontramos-lap401 {
        font-size: 40px;
        margin-top: 2%;
        margin-bottom: 2%;
    }
    .boton-ingresoo4011 {
        margin-top: 2%;
        height: 37px;
    }
    }
    </style> -->